import { type PBRMaterial } from '@babylonjs/core/Materials/PBR/pbrMaterial';
import { type Texture } from '@babylonjs/core/Materials/Textures/texture';
import { type ITransformRT2 } from '@seddi/math-v2';
import { textureSetTransform } from '../textures/texture';

/**
 * Applies RT transform to textures.
 * @param material - Material.
 * @param transform - RT transform.
 */
export const materialSetTexturesTransform = (material: PBRMaterial, transform: ITransformRT2) => {
  // NOTE: add all PBRMaterial textures we could be using
  material.albedoTexture && textureSetTransform(material.albedoTexture as Texture, transform);
  material.bumpTexture && textureSetTransform(material.bumpTexture as Texture, transform);
  material.reflectanceTexture &&
    textureSetTransform(material.reflectanceTexture as Texture, transform);
};
